import { render } from "./WorkspaceWizardModal.vue?vue&type=template&id=7da99d3e&scoped=true"
import script from "./WorkspaceWizardModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceWizardModal.vue?vue&type=script&lang=js"

import "./WorkspaceWizardModal.vue?vue&type=style&index=0&id=7da99d3e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da99d3e"]])

export default __exports__